module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/14gCrBa/tc-custom/9781118040522.jpg?1728327020120",
      "alt": "This image is the cover for the book Twilight in the Desert"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Twilight in the Desert\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Twilight in the Desert reveals a Saudi oil and production industry that could soon approach a serious, irreversible decline. In this exhaustively researched book, veteran oil industry analyst Matthew Simmons draws on his three-plus decades of insider experience and more than 200 independently produced reports about Saudi petroleum resources and production operations. He uncovers a story about Saudi Arabias troubled oil industry, not to mention its political and societal instability, which differs sharply from the globally accepted Saudi version. Its a story that is provocative and disturbing, based on undeniable facts, but until now never told in its entirety. Twilight in the Desert answers all readers questions about Saudi oil and production industries with keen examination instead of unsubstantiated posturing, and takes its place as one of the most important books of this still-young century.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Matthew R. Simmons\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("MATTHEW R. SIMMONS is Chairman of Simmons & Company International, a Houston-based investment bank that specializes in the energy industry. He now focuses on research, writing, and speaking engagements. Last year, he gave seventy-five speeches to a variety of groups, including energy industry conferences, university symposiums, and think tanks. Mr. Simmons is a member of the National Petroleum Council, a board member of Resources for the Future, and a Trustee of The Atlantic Council of the United States. He has an MBA from Harvard University.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wiley\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0